import React from 'react';
import { Inline, Stack, xcss } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { TabContainer } from '../../TabContainer.tsx';

// Todo: Wrap with TabContiner with FG clean up for phantom-3633-playbook-routes-migration
export const PlaybookListLoadingView = () => (
	<Stack
		space="space.250"
		grow="fill"
		xcss={wrapperStyles}
		testId="playbooks-list-screen.ui.playbook-list.edge-cases.loading"
	>
		<Inline space="space.100">
			<Skeleton height={32} width={240} borderRadius={4} isShimmering />
			<Skeleton height={32} width={120} borderRadius={4} isShimmering />
		</Inline>
		<Stack space="space.100">
			<LoadingRow />
			<LoadingRow />
			<LoadingRow />
		</Stack>
	</Stack>
);

const LoadingRow = () => (
	<Inline space="space.100">
		<Skeleton height={32} width="30%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="18%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="18%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="18%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="6%" borderRadius={4} isShimmering />
		<Skeleton height={32} width="10%" borderRadius={4} isShimmering />
	</Inline>
);

// Todo: Clean up with FG phantom-3633-playbook-routes-migration
export const PlaybookWrappedListLoadingView = () => (
	<TabContainer>
		<PlaybookListLoadingView />
	</TabContainer>
);

const wrapperStyles = xcss({
	paddingTop: 'space.300',
});
